import { useState } from "react";
import { Card, Input, Table, Tag, Button, Popconfirm, message, Space } from "antd";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, AdminGroup } from "../api";

export default function Groups() {
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 20;
  const qc = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ["admin-groups", q, page],
    queryFn: async () =>
      (await api.get<{ items: AdminGroup[] }>("/groups", { params: { q, limit: pageSize, offset: (page - 1) * pageSize } })).data,
  });

  const dissolve = useMutation({
    mutationFn: (id: string) => api.post(`/groups/${id}/dissolve`, {}),
    onSuccess: () => { message.success("已解散"); qc.invalidateQueries({ queryKey: ["admin-groups"] }); },
    onError: (e: any) => message.error(e?.response?.data?.error ?? "操作失败"),
  });

  const del = useMutation({
    mutationFn: (id: string) => api.delete(`/groups/${id}`),
    onSuccess: () => { message.success("已删除"); qc.invalidateQueries({ queryKey: ["admin-groups"] }); },
    onError: (e: any) => message.error(e?.response?.data?.error ?? "删除失败"),
  });

  return (
    <Card
      style={{ background: "#10131A", border: "1px solid #1A1D26" }}
      title={<span style={{ color: "#F5F5F7" }}>群组管理</span>}
      extra={<Input.Search placeholder="搜索群名" allowClear onSearch={(v) => { setQ(v); setPage(1); }} style={{ width: 280 }} />}
    >
      <Table<AdminGroup>
        rowKey="id"
        loading={isLoading}
        dataSource={data?.items}
        pagination={{ current: page, pageSize, total: data?.items?.length === pageSize ? page * pageSize + 1 : (page - 1) * pageSize + (data?.items?.length ?? 0), onChange: setPage, showSizeChanger: false }}
        columns={[
          { title: "名称", dataIndex: "name" },
          { title: "群主", dataIndex: "owner_name", render: (v) => v ?? <span style={{ color: "#6B7280" }}>—</span> },
          { title: "成员", dataIndex: "member_count", width: 110, render: (v: number, r) => `${v} / ${r.max_members}` },
          { title: "状态", dataIndex: "status", width: 100, render: (s: number) => s === 0 ? <Tag color="green">活跃</Tag> : <Tag color="red">已解散</Tag> },
          { title: "创建时间", dataIndex: "created_at", width: 180, render: (v) => new Date(v).toLocaleString() },
          {
            title: "操作", width: 160,
            render: (_, r) => (
              <Space>
                {r.status === 0 && (
                  <Popconfirm title="解散此群?" description="此操作不可逆。" onConfirm={() => dissolve.mutate(r.id)}>
                    <Button size="small" danger>解散</Button>
                  </Popconfirm>
                )}
                <Popconfirm title="确认删除此群?" onConfirm={() => del.mutate(r.id)}>
                  <Button size="small">删除</Button>
                </Popconfirm>
              </Space>
            ),
          },
        ]}
      />
    </Card>
  );
}
